import { Button } from '@zep-us/zus';
import { useTranslation } from 'next-i18next';
import { ExclamationmarkSmallCircleFillIcon } from '@/icons';
export const MapRecoveryNotice = ({
  onChangeMap
}: {
  onChangeMap: () => void;
}) => {
  const {
    t
  } = useTranslation(['build']);
  return <div className="flex w-full flex-col items-stretch gap-xs rounded-sm bg-red-50 px-md py-sm mobile-lg:flex-row mobile-lg:items-center mobile-lg:justify-between" data-sentry-component="MapRecoveryNotice" data-sentry-source-file="MapRecoveryNotice.tsx">
      <div className="flex min-w-0 items-center gap-xs">
        <ExclamationmarkSmallCircleFillIcon size="sm" className="shrink-0 text-destructive" data-sentry-element="ExclamationmarkSmallCircleFillIcon" data-sentry-source-file="MapRecoveryNotice.tsx" />
        <p className="min-w-0 text-body-md-semibold text-default">
          {t('build:build.lockRecovery.unavailableMapDescription')}
        </p>
      </div>
      <Button type="button" size="sm" variant="outlined" intent="destructive" onClick={onChangeMap} className="w-full shrink-0 whitespace-nowrap mobile-lg:w-auto" data-sentry-element="Button" data-sentry-source-file="MapRecoveryNotice.tsx">
        {t('build:build.lockRecovery.availableFreeMapAction')}
      </Button>
    </div>;
};